import { Spinner, Stack } from '@tymate/margaret';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { ButtonReset, LoadingLayout, Media, MediaBody, MediaImage, PlaceName, size } from '../ui';
import { useBreakpoint } from '../hooks';
import { useQuery } from 'react-query';
import { getCommercialCommunication } from '../api/communication';
import { DetailListItemExternalLink } from '../ui/Details';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { MdPause, MdPlayArrow } from 'react-icons/all';
import { getWindowWidth } from './MobileRoutes';
import { viewportSizes } from '../ui/utils';

const CarrouselContent = styled(Stack).attrs({
   direction: 'column',
   alignX: 'center',
   size: 'full',
   gutterSize: '2',
})`
   margin-top: ${props => !props.isMobile && '2rem'};
`;

const CustomSlider = styled(Slider)`
   .slick-slide > div {
      margin: 0 0.5rem;
   }

   width: ${props =>
      props.isDesktop ? (props.isWideScreen && props.moreThanTwoSlides ? '1050px' : '700px') : '350px'};
   margin-left: ${props => !props.isMobile && '1rem'};
`;

const ContainerSlider = styled.div`
   display: flex;
   justify-content: center;
   width: ${props => (props.isMobile ? '90%' : '100%')};
`;

const SliderArrow = styled(ButtonReset)`
   font-size: ${size(3)};

   &:before {
      color: ${({ theme }) => theme.primary};
   }
`;

const SliderPlay = styled(ButtonReset)`
   color: ${({ theme }) => theme.primary};
   font-size: ${size(3)};
`;
const Img = styled.img`
   max-height: 95px;
`;
const MediaCarrousel = styled(Media)`
   height: 65px;
   gap: 1rem;
`;
const MediaImageCarrousel = styled(MediaImage)`
   justify-content: center;
   width: ${props => (props.hasBody ? '50%' : '100%')};
`;
const MediaBodyCarrousel = styled(MediaBody)`
   width: ${props => (props.hasImage ? '50%' : '100%')};
   display: flex;
   justify-content: ${props => !props.hasImage && 'center'};
   padding-left: 0;
`;

const Carrousel = () => {
   const { isMobile } = useBreakpoint();
   const [showPlayButton, setShowPlayButton] = useState(false);
   const [showPauseButton, setShowPauseButton] = useState(true);
   let sliderRef = useRef(null);
   const isDesktop = getWindowWidth() >= viewportSizes.desktop;
   const isWideScreen = getWindowWidth() >= viewportSizes.wideScreen;
   const { data, isLoading, isFetching } = useQuery(
      ['getCommercialCommunication'],
      () => getCommercialCommunication(),
      {
         refetchOnWindowFocus: false,
      }
   );

   const handlePlay = () => {
      sliderRef.slickPlay();
      setShowPauseButton(true);
      setShowPlayButton(false);
   };
   const handlePause = () => {
      sliderRef.slickPause();
      setShowPauseButton(false);
      setShowPlayButton(true);
   };

   const settings = {
      infinite: Object.values(data?.data ?? []).length > 1,
      slidesToShow: isDesktop ? (isWideScreen && Object.values(data?.data ?? []).length > 2 ? 3 : 2) : 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      prevArrow: <SliderArrow />,
      nextArrow: <SliderArrow />,
   };

   return (
      <>
         {(isLoading || isFetching) && (
            <Stack direction='column' alignX='center' size='full'>
               <LoadingLayout>
                  <Spinner />
               </LoadingLayout>
            </Stack>
         )}
         {(!isLoading || !isFetching) && (
            <CarrouselContent isMobile={isMobile}>
               <ContainerSlider className='slider-container' isMobile={isMobile}>
                  <CustomSlider
                     ref={slider => (sliderRef = slider)}
                     {...settings}
                     isMobile={isMobile}
                     isDesktop={isDesktop}
                     isWideScreen={isWideScreen}
                     moreThanTwoSlides={Object.values(data?.data ?? []).length > 2}
                  >
                     {Object.values(data?.data ?? []).map((card, index) => (
                        <DetailListItemExternalLink href={card?.link} key={index}>
                           <MediaCarrousel center>
                              {card?.imageUri && (
                                 <MediaImageCarrousel hasBody={card?.text}>
                                    <Img src={card?.imageUri} alt='' />
                                 </MediaImageCarrousel>
                              )}
                              {card?.text && (
                                 <MediaBodyCarrousel hasImage={card?.imageUri}>
                                    <PlaceName>{card?.text}</PlaceName>
                                 </MediaBodyCarrousel>
                              )}
                           </MediaCarrousel>
                        </DetailListItemExternalLink>
                     ))}
                  </CustomSlider>
               </ContainerSlider>
               <Stack direction='column' alignX='center' marginBottom={1.5} marginLeft={1}>
                  {showPauseButton && (
                     <SliderPlay onClick={handlePause}>
                        <MdPause />
                     </SliderPlay>
                  )}
                  {showPlayButton && (
                     <SliderPlay onClick={handlePlay}>
                        <MdPlayArrow />
                     </SliderPlay>
                  )}
               </Stack>
            </CarrouselContent>
         )}
      </>
   );
};
export default Carrousel;
